<template>
  <div>
    <div class="head">
      <el-button size="small" type="primary" @click="dialogFormVisible = true">新增</el-button>
    </div>
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column prop="number" label="公用工程编号"></el-table-column>
        <el-table-column prop="name" label="公用工程名称"></el-table-column>
        <el-table-column prop="place" label="公用工程位置"></el-table-column>
        <el-table-column prop="neurogen" label="主要介质"></el-table-column>
        <el-table-column prop="automationControl" label="自动化控制方式"></el-table-column>
        <el-table-column prop="facility" label="主要设备设施"></el-table-column>
        <el-table-column prop="address" label="操作" width="120px">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="editBtn(row)">编辑</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="danger" @click="deleteBtn(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>

    <!-- 弹出框 -->
    <div class="formBox">
      <el-dialog title="公用工程" :visible.sync="dialogFormVisible" top="6vh" width="50%" @close="closeDialog">
        <div class="content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
                   size="small" style="width: 80%; margin-left: 10%">
            <el-form-item label="" label-width="0">
              <el-col :span="12">
                <el-form-item label="公用工程编号" prop="number">
                  <el-input v-model="ruleForm.number" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公用工程名称" prop="name">
                  <el-input v-model="ruleForm.name" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="" label-width="0">
              <el-col :span="12">
                <el-form-item label="公用工程位置" prop="place">
                  <el-input v-model="ruleForm.place" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公用工程类型" prop="type">
                  <el-input v-model="ruleForm.type" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="" label-width="0">
              <el-col :span="12">
                <el-form-item label="公用工程功能" prop="functionality">
                  <el-input v-model="ruleForm.functionality" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="主要介质" prop="neurogen">
                  <el-input v-model="ruleForm.neurogen" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="" label-width="0">
              <el-col :span="12">
                <el-form-item label="主要设备设施" prop="facility">
                  <el-input v-model="ruleForm.facility" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="周围环境" prop="environment">
                  <el-input v-model="ruleForm.environment" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="" label-width="0">
              <el-col :span="12">
                <el-form-item label="应急处置方法" prop="meetEmergencies">
                  <el-input v-model="ruleForm.meetEmergencies" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="自动化控制方式">
                  <el-input v-model="ruleForm.automationControl" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="相关照片">
              <el-upload
                  class="avatar-uploader"
                  action="/v1/trainMaterials/uploadFile"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess">
                <img v-if="ruleForm.pictureUrl" :src="host + ruleForm.pictureUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
<!--            <el-form-item label="" label-width="0">
              <el-col :span="10">
                <el-form-item label="经度（度）" prop="longitude">
                  <el-input v-model="ruleForm.longitude" />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="纬度（度）" prop="latitude">
                  <el-input v-model="ruleForm.latitude" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button size="small" type="primary" @click="isVisibleDrawMap = true">选择位置</el-button>
              </el-col>
            </el-form-item>-->
            <el-form-item label="备注">
              <el-input v-model="ruleForm.remark" type="textarea" :rows="3" />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer" style="margin:auto">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submit" size="small">确 定</el-button>
        </div>
      </el-dialog>
      <DrawMap v-if="isVisibleDrawMap" :drawType="'Point'" :closeDrawer="closeDrawer"></DrawMap>
    </div>
  </div>
</template>

<script>
import {pubEngineeringList, pubEngineeringDelete, pubEngineeringEdit, pubEngineeringAdd} from '@/api/processManager'
import DrawMap from "@/views/map/drawMap";

export default {
  name: 'ProcessPubEngineering',
  components: {
    DrawMap
  },
  data() {
    return {
      isVisibleDrawMap:false,
      tableData: [],
      limit: 10,
      curPage: 1,
      total: 0,
      ruleForm: {},
      rules: {
        number: [{ required: true, message: '请输入公用工程编号' }],
        name: [{ required: true, message: '请输入公用工程名称' }],
        place: [{ required: true, message: '请输入公用工程位置' }],
        type: [{ required: true, message: '请输入公用工程类型' }],
        functionality: [{ required: true, message: '请输入公用工程功能' }],
        neurogen: [{ required: true, message: '请输入主要介质' }],
        facility: [{ required: true, message: '请输入主要设备设施' }],
        environment: [{ required: true, message: '请输入周围环境' }],
        meetEmergencies: [{ required: true, message: '请输入应急处置方法' }],
      },
      dialogFormVisible:false
    }
  },
  created() {
    this.getData();
  },
  methods: {
    closeDrawer(drawData){
      if(drawData){
       this.ruleForm.longitude=drawData.positions[0];
        this.ruleForm.latitude=drawData.positions[1];
      }
      this.isVisibleDrawMap=false;
    },
    getData() {
      pubEngineeringList({ limit: this.limit, curPage: this.curPage, isPage: 1 }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    // 保存
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 编辑
          if(this.isEdit) {
            pubEngineeringEdit({ ...this.ruleForm }).then(res => {
              this.$message.success('编辑成功')
              this.dialogFormVisible = false
              this.getData()
            })
          }
          // 新增
          else {
            pubEngineeringAdd({ ...this.ruleForm }).then(res => {
              this.$message.success('新增成功')
              this.dialogFormVisible = false
              this.getData()
            })
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹出框的事件
    closeDialog() {
      this.ruleForm.resetFields()
      this.isEdit = false
    },

    editBtn(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === undefined || obj[i] === null || obj[i] === 'null' || obj[i] === '') {
          delete obj[i]
        }
      }
      this.dialogFormVisible = true
      this.isEdit = true
      this.ruleForm = obj;
    },
    deleteBtn(row) {
      this.$confirm('删除该条信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        pubEngineeringDelete(row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getData()
        })
      }).catch(() => {
        return
      });
    }
  }
}
</script>

<style scoped>
.formBox /deep/ .el-form-item {
  margin-bottom: 6px
}
.formBox /deep/ .el-form-item__error {
  padding-top: 2px
}
</style>
